import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import FormPageHeader from "../../utilities/FormPageHeader";

import {
  AppBar,
  Tab,
  Tabs,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  Grid,
  Stack,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "../../discount-master/DatepickerEditorComponent";
import jwtDecode from "jwt-decode";
import dayjs from "dayjs";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../../utilities/ListPageHeader";
import { confirmAlert } from "react-confirm-alert";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { toast } from "react-toastify";
import { grey } from "@mui/material/colors";
import AsyncSelect from "react-select/async";
import { LinearProgress } from "@material-ui/core";
import moment from "moment";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import { useNavigate } from "react-router-dom";
import GeneralDetails from "./EmployeeDetails/GeneralDetails";
import BankDetails from "./EmployeeDetails/BankDetails";
import AssetInfo from "./EmployeeDetails/AssetInfo";
import LeaveDetails from "./EmployeeDetails/LeaveDetails";
import "../expense-claim/expenseClaim.css";

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.displayMasters}`;
const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRangeByVendor}`; // ranges/search/findRangeByVendor
const priceGroupUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.priceGroup}`;
const factoryVendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
const uploadFileForDisplayMaster = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.uploadFileForDisplayMaster}`;

const UploadButton = styled(Button)(({ theme }) => ({
  fontSize: 11,
  color: "#fff !important",
  background: `${theme.palette.primary.main}`,
  borderRadius: 20,
  padding: "5px 10px",
  cursor: "pointer",
}));

const Upload = (params) => {
  const downloadFile = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.downloadFile}`;
  const downloadPath = `${downloadFile}/${params.data?.uploadWinnerFile}?path=${params.data?.uploadWinnerPath}`;
  const hiddenFileInput = useRef();
  const [winner, setWinner] = useState({
    name: params.node.data.uploadWinnerFile,
  });
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  async function remove() {
    // hiddenFileInput.current?.value = null;
    params.node.data.uploadWinnerFile = "";
    setWinner(null);
  }

  function uploadProgressChanged(params) {
    const { progress } = params;
    setUploadProgress(progress * 100);
  }
  const onChange = async (e) => {
    const fileUploaded = e.target.files[0];
    setUploading(true);
    if (!fileUploaded) return;
    const payload = {
      uploadWinnerFile: fileUploaded,
    };
    const response = await OAuthService.addFiles(
      `${uploadFileForDisplayMaster}?srNo=${params.data.srNo}`,
      payload,
      uploadProgressChanged
    );
    toast.success("Upload Successfully");
    params.node.updateData(response.data);
    setWinner(fileUploaded);
    setUploading(false);
    setUploadProgress(0);
  };

  const downloadFiles = async () => {
    const blob = await fetch(downloadPath, OAuthService.config()).then((resp) =>
      resp.blob()
    );
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = params.node?.data?.uploadWinnerFile;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(objUrl);
    document.body.removeChild(a);
  };

  return uploading ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" value={uploadProgress} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">
          {Math.round(uploadProgress)}%
        </Typography>
      </Box>
    </Box>
  ) : (
    <span>
      {!params.node.data.uploadWinnerFile && (
        <UploadButton
          variant="contained"
          component="label"
          fullWidth
          color="primary"
          ref={hiddenFileInput}
          onChange={onChange}
        >
          UPLOAD WINNER
          <input type="file" hidden />
        </UploadButton>
      )}
      {winner && (
        <>
          <Button
            variant="outlined"
            size="small"
            onClick={downloadFiles}
            startIcon={<FuseSvgIcon>heroicons-outline:download</FuseSvgIcon>}
          >
            Download
          </Button>
          <IconButton onClick={remove}>
            <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
          </IconButton>
        </>
      )}
    </span>
  );
};
const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      padding: "5px 10px",
      cursor: "pointer",

      "&:hover": {
        backgroundColor: grey[800],
      },
    },
    // borderRadius: "20px",
    fontSize: "11px",
    textAlign: "center",
    height: "26px",
    lineHeight: "26px",
    padding: "0px 10px",
    marginTop: "6px",
  },
}));
const currentDate = new Date();

export default function EmpDetails(props) {
  const classes = useStyles(props);
  const [tabValue, setTabValue] = useState("general-details");
  const { open, handleClose } = props;
  const [rowData, setRowData] = useState([]);
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const gridRef = useRef();
  const [addedRows, setAddedRows] = useState([]);
  const [productId, setProductId] = useState([]);
  const [countries, setCountries] = useState([]);
  const [configData, setConfigData] = useState([]);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [totalClaimed, setTotalClaimed] = useState();
  const [selectedCountry, setSelectedCountry] = useState();
  const navigate = useNavigate();

  const [docUpdate, setDocUpdate] = useState(false);
  const [initialState, setInitialState] = useState({
    docDate: currentDate,
    creationDate: new Date().toISOString(),
    employeeId: null,
    employeeName: null,
    companyCode: 1,
    companyName: "Nolte FZE",
    currency: "EUR",
    remark: null,
    financeDoc: "string",
    recordList: [],
  });

  const currencyOption = [
    // { label: "AED", value: "AED" },
    { label: "EUR", value: "EUR" },
    { label: "USD", value: "USD" },
    // { label: "(OTHER)", value: "(OTHER)" },
  ];

  const CellSuggestionsEditor = forwardRef((props, ref) => {
    const classes = useStyles(props);
    const { colDef, value } = props;
    const [values, setValues] = useState(
      props.api
        .getRenderedNodes()
        .map((node) => node.data[colDef.field])
        .filter((v) => v.replaceAll(" ", "").length > 0)
    );
    const [filteredValues, setFilteredValues] = useState([]);
    const inputRef = useRef(null);
    const [currentValue, setCurrentValue] = useState(value);
    useEffect(() => {
      inputRef.current.focus();
      setFilteredValues(values);
    }, []);
    const _handleChange = (e) => {
      const { value } = e.target;
      setCurrentValue(value);
      setFilteredValues(values.filter((val) => val.includes(value)));
    };
    useImperativeHandle(ref, () => {
      return {
        getValue: () => currentValue,
      };
    });
    return (
      <div ref={ref} className={clsx(classes.root)}>
        <TextField
          ref={inputRef}
          value={currentValue}
          onChange={_handleChange}
          fullWidth
        />
        {currentValue !== "" && currentValue !== null && (
          <Box component={"ul"} className="suggestions">
            {filteredValues.map((fv) => (
              <li
                className="suggestion-value"
                onClick={() => setCurrentValue(fv)}
              >
                {fv}
              </li>
            ))}
          </Box>
        )}
      </div>
    );
  });

  const handleCountry = async (params) => {
    let code = params.value;
    const claimConfig = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimConfig}/search/findByCountryCode?code=${code}`;

    const configResult = await OAuthService.getList(claimConfig);

    const data = configResult?.data?._embedded?.expenseClaimConfigs;

    setRowData(data);
    setSelectedCountry(params);
  };

  const SelectCurrency = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refLocation = useRef();
    const [error, setError] = useState("");
    let [options, setOptions] = useState([
      { label: "EUR", value: "EUR" },
      { label: "USD", value: "USD" },
    ]);
    const [selectedOptions, setSelectedOptions] = useState(null);

    const handleOptionsChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      setSelectedOptions(value);
      // setOpenCom(false);
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedOptions?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refLocation}
          value={selectedOptions}
          onChange={handleOptionsChange}
          options={options}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectCode = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refLocation = useRef();
    const [error, setError] = useState("");
    let [options, setOptions] = useState([
      { label: "52200-1-1 (Air Travel)", value: "Air Travel" },
      { label: "52200-1-2 (Hotel)", value: "Hotel" },
      { label: "52200-1-3 (Daily Allowance)", value: "Daily Allowance" },
      { label: "52200-1-4 (Visa Expenses)", value: "Visa Expenses" },
      { label: "52200-1-5 (Insurance Expenses)", value: "Insurance Expenses" },
      { label: "52200-1-6 (Client Welfare)", value: "Client Welfare" },
      { label: "52200-1-7 (Rent a Car)", value: "Rent a Car" },
      {
        label: "52200-1-8 (Petrol/Taxi Charges)",
        value: "Petrol/Taxi Charges",
      },
      { label: "52200-1-9 (Refreshment Exp)", value: "Refreshment Exp" },
      { label: "52200-1-10 (Communication)", value: "Communication" },
      { label: "52200-1-11 (Mobile)", value: "Mobile" },
      { label: "52200-1-12 (Parking)", value: "Parking" },
      { label: "52200-1-13 (Marketing)", value: "Marketing" },
      { label: "52200-1-14 (Training)", value: "Training" },
      { label: "52200-1-15 (Miscellenous)", value: "Miscellenous" },
    ]);
    const [selectedOptions, setSelectedOptions] = useState(null);

    const handleOptionsChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      props.data.subLedgerName = value.value;
      setSelectedOptions(value);
      // setOpenCom(false);
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedOptions?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refLocation}
          value={selectedOptions}
          onChange={handleOptionsChange}
          options={options}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectRange = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    console.log(props);
    const refRange = useRef();
    const [range, setRange] = useState([]);
    const [selectedRange, setSelectedRange] = useState(null);
    const [allItems, setAllItems] = useState([]);

    if (!productId) return;
    const getRangeList = async () => {
      if (!data.product) {
        alert("Please select a product first");
        return;
      }

      const findAllProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      console.log("PRoduct ID: ", data.productId);
      let productList = list.data.filter(
        (d) =>
          d.vendor
            .map((vendor) => vendor.id)
            .includes(Number(data.productId)) && "Range" === d._class
      );
      console.log(productList);
      setAllItems(productList);
      setRange(
        productList.map((range) => ({
          value: range.productId,
          label: range.productName,
        }))
      );
      // const range2 = ranges.filter((r) => r.productName === data[colDef.field]);
      // if (range2.length > 0)
      //   setSelectedRange({
      //     value: range2[0].productId,
      //     label: range2[0].productName,
      //   });
      return productList.map((range) => ({
        value: range.productId,
        label: range.productName,
      }));
      // OAuthService.getList(rangeUrl + `?vendorId=${data.productId}`)
      //   .then((list) => {
      //     const { ranges } = list.data?._embedded;
      //     console.log('ranges', ranges)

      //   })
      //   .catch((err) => setError(err.message));
    };

    const handleRangeChange = (value) => {
      if (!value) return;
      const selectedRange = allItems.filter(
        (item) => item.productName === value.label
      )[0];
      if (colDef.field === "range1")
        data.priceGroup = selectedRange?.priceGroup?.pgId;
      else if (colDef.field === "range2")
        data.priceGroup2 = selectedRange?.priceGroup?.pgId;
      console.log("value: ", data);
      setSelectedRange(value);
    };

    // useEffect(() => {
    //   getRangeList();
    // }, []);

    const _loadOptions = (input) =>
      new Promise((resolve, reject) => {
        getRangeList()
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedRange?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <AsyncSelect
          loadOptions={_loadOptions}
          className="basic-multi-select mb-4"
          ref={refRange}
          onChange={handleRangeChange}
          styles={customStyles()}
          required
          cacheOptions
          defaultOptions
        />
        {/* <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refRange}
          value={selectedRange}
          onChange={handleRangeChange}
          // // isMulti
          options={range}
          styles={customStyles()}
        /> */}
      </div>
    );
  });

  const SelectCarCass = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refCarCass = useRef();
    const [carCass, setCarCass] = useState([]);
    const [selectedCarCass, setSelectedCarCass] = useState(null);
    const [allItems, setAllItems] = useState([]);

    if (!productId) return;
    const getCarCassList = async () => {
      if (!data.product) {
        alert("Please select a product first");
        return;
      }
      const findAllProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      console.log("PRoduct ID: ", data.productId);
      let productList = list.data.filter(
        (d) =>
          d.vendor
            .map((vendor) => vendor.id)
            .includes(Number(data.productId)) && "Carcass" === d._class
      );
      // setAllItems(productList)
      setCarCass(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      // const cc = productList.filter(
      //   (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      // );
      // if (cc.length > 0)
      //   setSelectedFront({
      //     label: `${cc[0].productId} ${cc[0].productName}`,
      //     value: `${cc[0].productId} ${cc[0].productName}`,
      //   });
      return productList.map((product) => ({
        value: `${product.productId} ${product.productName}`,
        label: `${product.productId} ${product.productName}`,
      }));
    };

    const handleCarCassChange = (value) => {
      if (!value) return;
      setSelectedCarCass(value);
    };

    // useEffect(() => {
    //   getCarCassList();
    // }, []);

    const _loadOptions = (input) =>
      new Promise((resolve, reject) => {
        getCarCassList()
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedCarCass?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <AsyncSelect
          loadOptions={_loadOptions}
          className="basic-multi-select mb-4"
          ref={refCarCass}
          onChange={handleCarCassChange}
          styles={customStyles()}
          required
          cacheOptions
          defaultOptions
        />
        {/* <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refCarCass}
          value={selectedCarCass}
          onChange={handleCarCassChange}
          options={carCass}
          styles={customStyles()}
        /> */}
      </div>
    );
  });

  const token = jwtDecode(localStorage.getItem("token"));

  const handleTabChange = (event, value) => setTabValue(value);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return (
    <>
      <FormPageHeader
        componentName="List"
        pageName="Employee Details"
        currentPage="Employee Details"
      >
       <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className={clsx(classes.root)}
        >
          <Tab 
            label="General Details" 
            value={"general-details"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="Bank Details" 
            value={"bank-details"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="Documents" 
            value={"documents"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="Family Details" 
            value={"family-details"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="Asset Information" 
            value={"asset-info"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="Qualification" 
            value={"qualification"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="Leave" 
            value={"leave"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="Payslip Download" 
            value={"payslip-download"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="Expense Claim" 
            value={"company-paid-allowance"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
        </Tabs>
      </FormPageHeader>

      <div className="h-full pr-12 pl-12 w-full">
        {tabValue === "general-details" ? (
          <GeneralDetails />
        ) : tabValue === "bank-details" ? (
          <BankDetails />
        ) : tabValue === "asset-info" ? (
          <AssetInfo />
        ) : tabValue === "leave" ? (
          <LeaveDetails />
        ) : null}
      </div>
    </>
  );
}
